(() => {
  const toggle = document.querySelector('.category-menu-toggle');
  const menu = document.querySelector('#shop-menu');
  if (!toggle || !menu) return;
  const close = () => { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); });
  document.addEventListener('click', event => { if (!menu.contains(event.target) && !toggle.contains(event.target)) close(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
})();

(() => {
  const button = document.querySelector('.search-open');
  const dialog = document.querySelector('.search-dialog');
  if (!button || !dialog) return;
  const input = dialog.querySelector('input[type="search"]');
  const close = dialog.querySelector('.search-close');
  button.addEventListener('click', () => { dialog.showModal(); input?.focus(); });
  close?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
})();

(() => {
  const media = document.querySelector('[data-product-media]');
  const dots = Array.from(document.querySelectorAll('[data-gallery-dot]'));
  if (!media || dots.length < 2) return;
  const show = index => media.scrollTo({ left: index * media.clientWidth, behavior: 'smooth' });
  const update = () => {
    const index = Math.max(0, Math.min(dots.length - 1, Math.round(media.scrollLeft / media.clientWidth)));
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };
  dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
  media.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
